import { createApiSlice } from "@common";
import { CRUD_CONTACT_DEPARTMENT } from "@routes";

const apiConfig = [
  {
    name: "addContactDepartment",
    method: "post",
    url: CRUD_CONTACT_DEPARTMENT,
    stateKey: "message"
  },
  {
    name: "getContactDepartment",
    method: "get",
    url: CRUD_CONTACT_DEPARTMENT,
    stateKey: "data"
  },
  {
    name: "updateContactDepartment",
    method: "put",
    url: CRUD_CONTACT_DEPARTMENT,
    stateKey: "message"
  },
  {
    name: "deleteContactDepartment",
    method: "delete",
    url: CRUD_CONTACT_DEPARTMENT,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "contactDepartment",
  apiConfig,
  customReducers);
const contactDepartmentSlice = slice;

export default contactDepartmentSlice.reducer;

export const {
  addContactDepartment,
  getContactDepartment,
  updateContactDepartment,
  deleteContactDepartment
} = thunks;
export const { rowSelect } = actions;
